// extracted by mini-css-extract-plugin
export default {"xxGridActionPanel":"Form_xxGridActionPanel__5xXTk","UploadsForm":"Form_UploadsForm__pAuw2","xxAutorInput":"Form_xxAutorInput__AT5qW"};